/*
  gem-personalization.js — Gemtastic

  Dawn renders the product form with novalidate, so the browser will NOT enforce
  the `required` attribute on the ring size select. Without this file a customer
  can add a ring to the cart with no size on the line, which is the defect we are
  fixing. So we validate ourselves.

  Listener is registered on `document` in the CAPTURE phase: capture on an
  ancestor always fires before Dawn's own bubble-phase submit handler on the
  form, so we can stop the add-to-cart before it starts.
*/
(function () {
  'use strict';

  var ENGRAVE_OK = /^[A-Za-z0-9 .&'\-]*$/;

  function fieldsFor(form) {
    if (!form) return [];
    var id = form.getAttribute('id');
    var all = Array.prototype.slice.call(
      document.querySelectorAll('[data-gem-required], [data-gem-engrave]')
    );
    return all.filter(function (el) {
      return (id && el.getAttribute('form') === id) || form.contains(el);
    });
  }

  function errorFor(el) {
    var wrap = el.closest('.gem-field');
    return wrap ? wrap.querySelector('[data-gem-error]') : null;
  }

  function show(el, on) {
    var err = errorFor(el);
    if (err) err.hidden = !on;
    el.setAttribute('aria-invalid', on ? 'true' : 'false');
    el.classList.toggle('gem-field--invalid', !!on);
  }

  function validate(el) {
    if (el.hasAttribute('data-gem-required')) {
      var ok = String(el.value || '').trim() !== '';
      show(el, !ok);
      return ok;
    }
    if (el.hasAttribute('data-gem-engrave')) {
      var v = String(el.value || '');
      var good = v.length <= 16 && ENGRAVE_OK.test(v);
      show(el, !good);
      return good;
    }
    return true;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

      var bad = null;
      fieldsFor(form).forEach(function (el) {
        if (!validate(el) && !bad) bad = el;
      });

      if (bad) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var pf = form.closest('product-form');
        var wrap = pf ? pf.querySelector('.product-form__error-message-wrapper') : null;
        if (wrap) {
          var msg = wrap.querySelector('.product-form__error-message');
          if (msg) msg.textContent = bad.hasAttribute('data-gem-required')
            ? 'Choose your ring size above, then add to cart.'
            : 'Check the engraving text above, then add to cart.';
          wrap.hidden = false;
        }
        bad.focus();
        if (bad.scrollIntoView) bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    true
  );

  document.addEventListener('input', handle);
  document.addEventListener('change', handle);

  function handle(event) {
    var el = event.target;
    if (!el || !el.hasAttribute) return;

    if (el.hasAttribute('data-gem-engrave')) {
      var wrap = el.closest('.gem-field');
      var count = wrap ? wrap.querySelector('[data-gem-count]') : null;
      if (count) count.textContent = String(el.value || '').length + '/16';
    }

    if (el.hasAttribute('data-gem-required') || el.hasAttribute('data-gem-engrave')) {
      if (el.getAttribute('aria-invalid') === 'true') validate(el);
    }
  }
})();